"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpProgressLinear = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
require("./styles.scss");
const progress_linear_html_1 = __importDefault(require("./progress-linear.html"));
let ItpProgressLinear = class ItpProgressLinear extends vue_property_decorator_1.Vue {
};
exports.ItpProgressLinear = ItpProgressLinear;
exports.ItpProgressLinear = ItpProgressLinear = __decorate([
    (0, vue_property_decorator_1.Component)({ template: progress_linear_html_1.default })
], ItpProgressLinear);
//# sourceMappingURL=progress-linear.js.map